import { BrandingSettings } from '../types/branding.ts';

export const defaultBranding: BrandingSettings = {
  colors: {
    primary: '#5B6FED',
    secondary: '#8B5CF6',
    accent: '#06B6D4',
    background: '#FFFFFF',
    foreground: '#000000',
  },
  companyName: 'Schedule Hero AI',
  customCopy: {
    welcomeMessage: 'Welcome to our AI scheduling platform',
    aiName: 'Jade',
    ctaText: 'Start Your Free Trial',
    tagline: 'Intelligent scheduling made simple',
    aiGreeting: 'Hi, thank you for calling, this is Jade, the AI assistant. How can I help?',
    successTitle: 'Success! Your AI Employee is Ready!',
    successMessage: 'is now active and ready to help your customers.',
    getStartedText: 'Get Started',
    welcomeTitle: "Welcome! Let's set up your AI Employee.",
    welcomeSubtitle: "We'll get your AI ready to handle calls in about 5 minutes. We just need a few key details to start.",
    dashboardButtonText: 'Go to Dashboard',
  },
  fromEmail: 'no-reply@notify.scheduleheroai.com', // Will be overridden dynamically
  replyToEmail: 'no-reply@notify.scheduleheroai.com', // Will be overridden dynamically
  emailStatus: 'active',
  baseUrl: 'https://app.schedulehero.ai', // Will be overridden dynamically
  helpCenterContent: '',
};